/**
 * Data från Backend
 * @param Value Text för checkboxen
 * @param Key Värde för checkboxen
 */
export class ServerTreeViewData {
    constructor(
        public Value: string,
        public Key: string
    ) { }

    public Children: ServerTreeViewData[];
}
